import {markupFormatter, MarkupTree} from "../../common";

export function invertCard(markup: string): string {
    const cardTree = markupFormatter.parse(markup);
    const invertedTree = new MarkupTree();
    invertedTree.question = cardTree.answer;
    invertedTree.hint = cardTree.hint;
    invertedTree.answer = cardTree.question;
    invertedTree.tags = cardTree.tags;
    invertedTree.footer = cardTree.footer;
    invertedTree.icon = cardTree.icon;  // Preserve the icon

    return markupFormatter.format(invertedTree);
}
